<template>
  <div class="about-block">
    <div class="container small-container">
      <h2 class="section-header">
        About Make It Cheaper
      </h2>
      <p>Since 2007, we’ve helped over 250,000 UK businesses like yours save the time, money and frustration of dealing with business essentials. With us, you can say goodbye to the tedious phone calls and cringey sales patter, we get your telecoms sorted with zero faff. </p>
      <p>So, leave your due diligence to us. We’ll ensure you’re always getting the contract at the right price.</p>

      <div class="about-block__kpi">
        <div class="about-block__kpi-card">
          <span class="about-block__kpi-title">Established</span>
          <span class="about-block__kpi-figure">2007</span>
        </div>
        <div class="about-block__kpi-card">
          <span class="about-block__kpi-title">Businesses helped</span>
          <span class="about-block__kpi-figure">250k</span>
        </div>
        <div class="about-block__kpi-card">
          <span class="about-block__kpi-title">Average call</span>
          <span class="about-block__kpi-figure">6 mins</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutBlock'
}
</script>

<style lang="scss">
.about-block {
  padding: $spacing-60 $spacing-0;
  background-color: $about-block-bg;
  text-align: left;

  @media (max-width: $screen-md) {
    padding: $spacing-20 $spacing-0;
  }

  &__kpi {
    display: flex;
    flex-direction: column;
    margin: $spacing-28 auto $spacing-0;
  }

  &__kpi-card {
    display: flex;
    flex-direction: column;
    padding-bottom: $spacing-16;
    border-bottom: 2px solid $about-border;

    &:last-child {
      padding-bottom: $spacing-0;
      border-bottom: none;
    }
  }

  &__kpi-title {
    margin-bottom: $spacing-12;
    font-size: 20px;
    font-weight: bold;

    @media (max-width: $screen-md) {
      margin-top: $spacing-12;
    }
  }

  &__kpi-figure {
    font-size: 48px;
    line-height: 48px;
    color: $about-color;
  }

  @media (min-width: $screen-md) {
    text-align: center;

    &__kpi {
      flex-direction: row;
      justify-content: space-between;
    }

    &__kpi-card {
      height: 180px;
      width: 180px;
      justify-content: center;
      margin: $spacing-0 auto;
      border-radius: 50%;
      background-color: $about-background;
      padding-bottom: $spacing-0;
    }

    &__kpi-title {
      margin-bottom: $spacing-0;
      font-size: 16px;
      line-height: 19px;
    }

    &__kpi-figure {
      font-size: 40px;
      color: $about-color;
    }
  }
}
</style>
